module.exports = __webpack_public_path__ + "img/tik-tok-cricle.b8970783.svg";